import { weight } from '../../mixins/Weight.js';
export const weightToSize: Record<weight, number> = {
  low: 24,
  normal: 32,
  high: 40
};